import createPalette from '@material-ui/core/styles/createPalette';

export const DEPV_GREY = '#6b675d';
export const DEPV_ORANGE = '#E15D00';
export const DEPV_ORANGE_LIGHT = '#FFA86A';

export const orange = {
  light: '#f9d1ad',
  medium: '#FFA86A',
  dark: '#EE7203',
  active: '#D04F02',
};

export const enplus_orange = {
  light: '#FFCD59',
  medium: '#FC9C16',
  dark: '#EE7203',
  active: '#D04F02',
};

export const orange_depv = {
  light: '#f9d1ad',
  medium: DEPV_ORANGE_LIGHT,
  dark: DEPV_ORANGE,
  active: '#D04F02',
};

export const text = {
  black: '#000000',
  grey1: '#858073',
  grey2: '#BBBBBB',
  grey3: '#EFEFEF',
};

export const createEditorPalette = (defaultPalette, customPalette = {}) =>
  createPalette({ ...defaultPalette, ...customPalette });

export const editor = {
  text: {
    default: text.black,
  },
  primary: {
    main: orange.dark,
  },
  secondary: {
    main: orange.light,
  },
};
